
import React, { useState, useEffect, useContext } from "react";
import ViewForm from "./ViewForm";
import { useParams } from 'react-router-dom'
import ViewHistoryForm from "./ViewHistoryForm";








const ViewHistory = () => {
    const { id } = useParams()
    

    return (
        <div className="flex flex-col  max-w-[100vw] mx-auto  ">
            <ViewHistoryForm id={id} />
        </div>
    )
}



export default ViewHistory;



